/**
 * @deprecated Preview localStorage ticks removed — use contestSubmissionStatus API instead.
 * Kept only so old keys can be cleared on load.
 */
const STORAGE_KEY = 'encyc_contest_entry_submitted_v1';

/** Clear legacy preview submission flags (they showed ticks without real uploads). */
export function clearLegacyContestSubmissionPreview(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
